module.exports = __webpack_public_path__ + "static/media/ice6.b2f3f2c2.png";